import AppDataService from "./AppDataService";

const COMMON_BASE = 'Shortcut'

export default class ShortcutDataService {
    static async uploadFile(data) {
        return await AppDataService.post(`${COMMON_BASE}/UploadFile`, data);
    }

    static async sendFile() {
        return await AppDataService.post(`${COMMON_BASE}/FileShare`);
    }

    static async checkStatus(params) {
        return await AppDataService.get(`${COMMON_BASE}/CheckStatus`, {params});
    }

    static async getGenerateSummaryFilterData() {
        return await AppDataService.get(`${COMMON_BASE}/GetSummaryDropDownDataList`);
    }

    static async getGeneratedSummaryData(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetGeneratedSummary`, data);
    }

    static async getPdfPreview(params) {
        return await AppDataService.get(`${COMMON_BASE}/PdfPreview`, {params});
    }

    static async downloadPDFsForSelectedPayer(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownloadPDFsForSelectedPayer`, {params});
    }

    static async downloadPDFsForAllPayers(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownloadPDFsForAllPayers`, {params});
    }

    static async downloadAllPDFs(data) {
        return await AppDataService.post(`${COMMON_BASE}/DownloadPDFsByFormType`, data);
    }


}